export enum Device {
    safari = "safari",
    firefox = "firefox",
    chrome = "chrome",
    opera = "opera",
    edge = "edge"
}